import React from 'react';
import { Box, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { parseDomain } from '@wix/domains-serverless-interface';
export const DomainNameError = _ref => {
  let {
    translationKey,
    args = {},
    children
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const {
    tld,
    formattedInput
  } = parseDomain((args == null ? void 0 : args.domainName) ?? '');
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    marginTop: "SP4",
    textAlign: "center"
  }, children ? children : translationKey ? /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, t(translationKey, {
    ...args,
    tld: `.${tld}`,
    domainName: formattedInput
  })) : null);
};
//# sourceMappingURL=DomainNameError.js.map